import React from 'react';
import TokenStack from './TokenStack';
import { fmt } from '../utils';
import { useTheme } from '../theme';
import { useIsMobile } from '../useMediaQuery';

export default function Ticker({ pools, onSelectPool }) {
  const { colors } = useTheme();
  const isMobile = useIsMobile();
  const items = [...pools, ...pools];

  return (
    <div style={{
      background: colors.bg,
      borderBottom: `1px solid ${colors.border}`,
      overflow: "hidden",
      whiteSpace: "nowrap",
      padding: isMobile ? "6px 0" : "10px 0",
      transition: "background-color 0.3s ease, border-color 0.3s ease",
    }}>
      <div style={{
        display: "inline-flex",
        animation: "ticker 30s linear infinite",
        gap: isMobile ? 20 : 32,
      }}>
        {items.map((p, i) => (
          <div key={p.id + '-' + i} onClick={() => onSelectPool && onSelectPool(p)} style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            flexShrink: 0,
            cursor: "pointer",
            padding: "4px 8px",
            borderRadius: 6,
            transition: "background 0.15s",
          }}
          onMouseEnter={e => e.currentTarget.style.background = colors.hover}
          onMouseLeave={e => e.currentTarget.style.background = "transparent"}
          >
            <TokenStack tokens={p.tokens} size={isMobile ? 16 : 20} />
            <span style={{
              fontFamily: "'IBM Plex Mono', monospace",
              fontSize: isMobile ? 9 : 11,
              color: colors.textSecondary,
              fontWeight: 500,
            }}>
              {p.name}
            </span>
            <span style={{
              fontFamily: "'DM Serif Display', serif",
              fontSize: isMobile ? 10 : 13,
              color: p.apr > 20 ? colors.gold : colors.green,
              fontWeight: 400,
            }}>
              {(p.apr || 0).toFixed(2)}%
            </span>
            {!isMobile && (
              <span style={{
                fontFamily: "'IBM Plex Mono', monospace",
                fontSize: 10,
                color: colors.labelLight,
              }}>
                {fmt(p.tvl)}
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
